/*

Jelly.Connections.Eventbrite_Get_Variable = function (Parameters) {
	// Find string position
	var Variable_Occurrence = Parameters.Content.indexOf(Parameters.Variable);
	// Get next two positions of '
	var Variable_Start = Parameters.Content.indexOf("'", Variable_Occurrence);
	var Variable_End = Parameters.Content.indexOf("'", Variable_Start);
	
	// Get characters in between and return
	return Parameters.Content.substring(Variable_Start + 1, Variable_End);
}

Jelly.Connections.Setup_Eventbrite = function (Parameters) {
	var Eventbrite_URL = 'https://www.eventbriteapi.com/v3/events/' + Parameters.Event_ID + '/ticket_classes?token=' + Parameters.Token;
	var Eventbrite_Ticket_ID = null;
	var Eventbrite_Available_Stock = null;

	// Get ticket ID & remaining tickets
	$.getJSON(Eventbrite_URL, null, function (data) { 
		$.each(data.ticket_classes, function (key, Eventbrite_Ticket) {
			if (Eventbrite_Ticket.on_sale_status == "AVAILABLE") {	
				Eventbrite_Ticket_ID = Eventbrite_Ticket.id;
				Eventbrite_Available_Stock = Eventbrite_Ticket.quantity_total - Eventbrite_Ticket.quantity_sold
				return false;
			}
		})
	});	
	
	// Create new order
	var Eventbrite_Order_Starter_URL = 'https://www.eventbrite.com/tickets-external?eid=' + Parameters.Event_ID + '&ref=etckt';
	console.log(Eventbrite_Order_Starter_URL);
	var Eventbrite_Order_Starter_HTML = $.get(Eventbrite_Order_Starter_URL, null, function (data) {
		console.log("IN");
		Jelly.Connections.Order_Start_UUID = Jelly.Connections.Eventbrite_Get_Variable({
				Content: Eventbrite_Order_Starter_HTML
			,	Variable: 'orderStartUuid'
		});
		Jelly.Connections.Order_Start_Signature = Jelly.Connections.Eventbrite_Get_Variable({
				Content: Eventbrite_Order_Starter_HTML
			,	Variable: 'orderStartSginature'
		});
	});
}
*/

Jelly.Connections.Continue_To_Eventbrite = function (Parameters) {	

	// Show disclaimer
	Jelly.Interface.Create_Window({
				Alias: 'Eventbrite_Redirect_Disclaimer'			
			,	URL: '/Block/Eventbrite_Redirect_Disclaimer'
		});

	var Continue_URL = 'https://www.eventbrite.com/orderstart?eid=' + Parameters.Event_ID + '&has_javascript=1&legacy_event_page=1&quant_' + Parameters.Ticket_ID + '_None=' + Parameters.Quantity + '&order_start_uuid=' + Parameters.Order_Start_UUID + '&order_start_signature=' + Parameters.Order_Start_Signature;
	
	if (Parameters.Eventbrite_Version)
			Continue_URL+= '&payment_type=eventbrite';
	if (Parameters.Discount)
			Continue_URL += "&discount=" + Parameters.Discount;

	console.log(Continue_URL);

	window.location = Continue_URL;
}